module.exports = __webpack_public_path__ + "img/avatar_user_bidv.677c1697.svg";